import * as wjcSheet from '@grapecity/wijmo.grid.sheet';

import { UnitOperationFlexSheetEventHandler } from './unit-operation-flex-sheet-event-handler';
import { Pipe } from '../../../_models/_unit-operations/pipe';
import { enumValuesToArray } from '../../../_utils/enum-values-to-array';
import { PipeSheetRows, PipeCellConfig } from '../cell-config/pipe-cell-config';
import { NumberToSimulationVariableMapper } from '../mappers/number-to-simulation-variable-mapper';
import { FlexSheetValueConverter } from '../flex-sheet-value-converter';
import { PipeFlexSheetMapper } from '../mappers/pipe-flex-sheet-mapper';

export class PipeFlexSheetEventHandler implements UnitOperationFlexSheetEventHandler {
  constructor(private valueConverter: FlexSheetValueConverter) {}

  handle(unitOperation: Pipe, spreadsheet: wjcSheet.FlexSheet, flexSheetEvent, rawValue) {
    const { row } = flexSheetEvent;

    if (enumValuesToArray(PipeSheetRows).indexOf(row) === -1) {
      flexSheetEvent.cancel = true;
      return;
    }

    const cellConfig = PipeCellConfig.find(rowConfig => rowConfig.row === row);
    const convertedValue = this.valueConverter.convert(spreadsheet, rawValue, cellConfig);

    const simulationVariableMapper = new NumberToSimulationVariableMapper();
    const mapper = new PipeFlexSheetMapper(simulationVariableMapper);

    mapper.map(unitOperation, row, convertedValue);
  }
}
